
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCustomerSurveyPosDialog extends Serenity.EntityDialog<PsCustomerSurveyPosRow, any> {
        protected getFormKey() { return PsCustomerSurveyPosForm.formKey; }
        protected getIdProperty() { return PsCustomerSurveyPosRow.idProperty; }
        protected getLocalTextPrefix() { return PsCustomerSurveyPosRow.localTextPrefix; }
        protected getNameProperty() { return PsCustomerSurveyPosRow.nameProperty; }
        protected getService() { return PsCustomerSurveyPosService.baseUrl; }
        protected getDeletePermission() { return PsCustomerSurveyPosRow.deletePermission; }
        protected getInsertPermission() { return PsCustomerSurveyPosRow.insertPermission; }
        protected getUpdatePermission() { return PsCustomerSurveyPosRow.updatePermission; }

        protected form = new PsCustomerSurveyPosForm(this.idPrefix);

    }
}